import { render } from "./GenerateInvoice.vue?vue&type=template&id=7957b876"
import script from "./GenerateInvoice.vue?vue&type=script&lang=js"
export * from "./GenerateInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__